import React from "react";

const Title = ({ children }) => (
  <h2 className="text-sm font-semibold text-slate-700 dark:text-slate-300 mb-3">{children}</h2>
);

export default Title;
